export enum SortType {
  'AtoZ',
  'new',
  'ZtoA',
  'ascendingPrice',
  'descendingPrice',
  'loading',
}

type SortDate<ITEM> = {
  getDate: (item: ITEM) => Date
  name: string
  type: SortType.new
}
type SortTitle<ITEM> = {
  getTitle: (item: ITEM) => string
  name: string
  type: SortType.AtoZ | SortType.ZtoA
}
type SortPrice<ITEM> = {
  getTitle: (item: ITEM) => string
  name: string
  type: SortType.ascendingPrice | SortType.descendingPrice
}
type SortLoading = {
  name: string
  type: SortType.loading
}

export type Sort<ITEM> = SortDate<ITEM> | SortTitle<ITEM> | SortPrice<ITEM> | SortLoading

export function sort<ITEM>(items: ITEM[], sort: Sort<ITEM>): ITEM[] {
  switch (sort.type) {
    case SortType.AtoZ:
      return sortAtoZ(items, sort.getTitle)

    case SortType.new:
      return sortDate(items, sort.getDate)

    case SortType.ZtoA:
      return sortZtoA(items, sort.getTitle)

    case SortType.ascendingPrice:
      return sortAscendingPrice(items)

    case SortType.descendingPrice:
      return sortDescendingPrice(items)

    default:
      return items
  }
}

// TODO sortAscendingPrice
function sortAscendingPrice<ITEM>(items: ITEM[]): ITEM[] {
  return items
}

// TODO sortDescendingPrice
function sortDescendingPrice<ITEM>(items: ITEM[]): ITEM[] {
  return items
}

function sortDate<ITEM>(items: ITEM[], getDate: (item: ITEM) => Date): ITEM[] {
  return items.sort(function (itemA, itemB) {
    const dateA = getDate(itemA)
    const dateB = getDate(itemB)
    if (isNaN(dateA.getTime())) {
      return -1
    }
    if (isNaN(dateA.getTime())) {
      return 1
    }

    if (dateA > dateB) {
      return -1
    }
    if (dateA < dateB) {
      return 1
    }
    return 0
  })
}

function sortAtoZ<ITEM>(items: ITEM[], getTitle: (item: ITEM) => string): ITEM[] {
  return items.sort(function (itemA, itemB) {
    return getTitle(itemA).localeCompare(getTitle(itemB))
  })
}

function sortZtoA<ITEM>(items: ITEM[], getTitle: (item: ITEM) => string): ITEM[] {
  return items.sort(function (itemA, itemB) {
    return -getTitle(itemA).localeCompare(getTitle(itemB))
  })
}
